import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { createStyles, FormControl, FormHelperText, Input, InputAdornment, InputProps } from '@mui/material'

import withFormFunctionality, { FormElementProps } from '~shared/components/reactHookForm/withFormFunctionality.hoc'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

// improvement proposal -- implement modifying value onChange
// improvement proposal -- implement modifying value onBlur
type Props = Omit<InputProps, 'value'> & FormElementProps & {
  prefix?: string
  suffix?: string
}

const FormTextFieldRedesign: React.FC<Props> = (props) => {
  const { validationError, defaultValue, prefix, suffix, ...rest } = props
  const { control } = useFormContext()

  return <Controller
    control={control}
    name={props.name}
    defaultValue={defaultValue || ''}
    render={(controllerProps) => {
      const handleOnBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onBlur && props.onBlur(event)
        controllerProps.onBlur()
      }

      const handleOnChange = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        props.onChange && props.onChange(event)
        controllerProps.onChange(event)
      }

      return <FormControl fullWidth>
        <Input
          error={!!validationError}
          value={controllerProps.value}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          endAdornment={suffix && <InputAdornment position='start'>{suffix}</InputAdornment>}
          startAdornment={prefix && <InputAdornment position='start'>{prefix}</InputAdornment>}
          fullWidth
          {...rest}
        />
        <FormHelperText style={{ margin: 0 }} error={!!validationError}>{props.label}{props.required ? '*' : ''}</FormHelperText>
      </FormControl>
    }}
  />
}

export default withFormFunctionality<Props>(FormTextFieldRedesign)
